import { render, staticRenderFns } from "./TextMessageEditorDialog.vue?vue&type=template&id=200521e8&scoped=true&"
import script from "./TextMessageEditorDialog.vue?vue&type=script&lang=js&"
export * from "./TextMessageEditorDialog.vue?vue&type=script&lang=js&"
import style0 from "./TextMessageEditorDialog.vue?vue&type=style&index=0&id=200521e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200521e8",
  null
  
)

export default component.exports